"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpExclude = void 0;
const util_1 = require("@app/util");
class IpExclude {
    constructor(options) {
        this._initSession();
        this.initializeOptions(options);
        this.request = new util_1.Request(this.endpoint, this.session);
    }
    async check() {
        try {
            const response = await this.request.get(this.endpoint);
            this.onCheckSuccess?.(response);
            return response;
        }
        catch (e) {
            console.error('IpExclude: check error', e);
            this.onCheckFailed?.(e);
        }
    }
    _initSession() {
        if (window.bicrmTracking) {
            this.session = window.bicrmTracking.session;
        }
        else {
            throw new Error('IpExclude: bicrmTracking not found');
        }
    }
    initializeOptions(options) {
        if (!options.endpoint) {
            throw new Error('IpExcludeOptions.endpoint is required');
        }
        this.endpoint = options.endpoint;
        this.onCheckFailed = options.onCheckFailed;
        this.onCheckSuccess = options.onCheckSuccess;
    }
}
exports.IpExclude = IpExclude;
__exportStar(require("./types"), exports);
